import React, { Fragment, useState, useEffect, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import {
  HeatMap,
  Map,
  InfoWindow,
  Marker,
  GoogleApiWrapper,
} from "google-maps-react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { BusinessCenter } from "@material-ui/icons";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Alert from "@material-ui/lab/Alert";
import axios from "axios";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Skeleton from "@material-ui/lab/Skeleton";
import Box from "@material-ui/core/Box";

import LoadFilterActors from "../../components/services/LoadFilterActors";
import LoadFilterCitys from "../../components/services/LoadFilterCitys";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

function MapRegistrationAll_web(props) {
  const classes = useStyles();
  const [loader, setLoader] = useState(true);
  const [showingInfoWindow, setShowingInfoWindow] = useState(false);
  const [activeMarker, setActiveMarker] = useState({});
  const [selectedPlace, setSelectedPlace] = useState({});
  const [radioValue, setRadioValue] = useState("b");
  const [selectedValue, setSetSelectedValue] = useState("b");
  const [error, setError] = useState(false);
  const [stores, setStores] = useState([]);
  const [storesValues, setStoresValues] = useState([]);
  const [heat, setHeat] = useState([]);
  const [disabledCity, setDisabledCity] = useState(true);
  const coords = { lat: parseFloat(-0.180653), lng: parseFloat(-78.4678348) };
  let result;

  const [values, setValues] = useState({
    actor: "",
    city: "",
    cityData: [],
  });

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  useEffect(() => {
    axios
      .get(`${urlServices}stakeholders`, {
        headers: {
          application: keyAplication,
        },
      })
      .then(
        (response) => {
          setStores(response.data);
          setStoresValues(response.data);
          setHeat(response.data);
          setLoader(false);
        },
        (error) => {
          console.log(error);
          setError(true);
        }
      );
  }, [keyAplication, urlServices]);

  const onMarkerClick = (props, marker) => {
    setSelectedPlace(props);
    setShowingInfoWindow(true);
    setActiveMarker(marker);
  };

  const displayMarkers = () => {
    return stores.map((store, index) => {
      return (
        <Marker
          key={index}
          id={index}
          position={{
            lat: parseFloat(store.lat),
            lng: parseFloat(store.lon),
          }}
          disableDefaultUI={true}
          /*icon={{
            url: "../../images/mujer.png",
            anchor: new props.google.maps.Point(20, 20),
            scaledSize: new props.google.maps.Size(20, 20),
          }}*/
          name={store.stakeholder_name}
          description={store.description}
          profile_name={store.profile_name}
          city={store.city_name}
          sector_name={store.sector_name}
          onClick={onMarkerClick}
        />
      );
    });
  };

  const gradient = [
    /*"rgba(102, 255, 0, 0)",
    "rgba(102, 255, 0, 0)",
    "rgba(102, 255, 0, 0)",

    "rgba(102, 255, 0, 1)",
    "rgba(102, 255, 0, 1)",
    "rgba(102, 255, 0, 1)",
    "rgba(102, 255, 0, 1)",
    "rgba(102, 255, 0, 1)",

    "rgba(147, 255, 0, 1)",
    "rgba(147, 255, 0, 1)",
    "rgba(147, 255, 0, 1)",
    "rgba(147, 255, 0, 1)",
    "rgba(147, 255, 0, 1)",

    "rgba(193, 255, 0, 1)",
    "rgba(193, 255, 0, 1)",
    "rgba(193, 255, 0, 1)",
    "rgba(193, 255, 0, 1)",
    "rgba(193, 255, 0, 1)",

    "rgba(238, 255, 0, 1)",
    "rgba(238, 255, 0, 1)",
    "rgba(238, 255, 0, 1)",
    "rgba(238, 255, 0, 1)",
    "rgba(238, 255, 0, 1)",

    "rgba(244, 227, 0, 1)",
    "rgba(249, 198, 0, 1)",
    "rgba(255, 0, 0, 1)",*/
    "rgba(0, 255, 255, 0)",
    "rgba(0, 255, 255, 1)",
    "rgba(0, 191, 255, 1)",
    "rgba(0, 127, 255, 1)",
    "rgba(0, 63, 255, 1)",
    "rgba(0, 0, 255, 1)",
    "rgba(0, 0, 223, 1)",
    "rgba(0, 0, 191, 1)",
    "rgba(0, 0, 159, 1)",
    "rgba(0, 0, 127, 1)",
    "rgba(63, 0, 91, 1)",
    "rgba(127, 0, 63, 1)",
    "rgba(191, 0, 31, 1)",
    "rgba(255, 0, 0, 1)",
  ];

  const handleChange = (event) => {
    setRadioValue(event.target.value);
    setSetSelectedValue(event.target.value);
  };

  const getResponseActor = (pro) => {
    setStores(storesValues);
    setHeat(storesValues);
    setValues({ ...values, city: "", cityData: [] });
    setDisabledCity(true);
    setRadioValue("b");
    setSetSelectedValue("b");

    if (pro !== null) {
      setValues({ ...values, actor: pro.code, city: "", cityData: [] });
      setDisabledCity(false);

      result = storesValues.filter(
        (filtered) => filtered.profile_id === pro.code
      );
      setStores(result);
      setHeat(result);
    }
  };

  const getResponseCity = (pro) => {
    result = storesValues.filter(
      (filtered) => filtered.profile_id === values.actor
    );
    setStores(result);
    setHeat(result);

    setValues({ ...values, city: "", cityData: [] });
    setRadioValue("b");
    setSetSelectedValue("b");

    if (pro !== null) {
      setValues({ ...values, city: pro.idCiudad, cityData: pro });

      result = storesValues.filter(
        (filtered) =>
          filtered.city_id === pro.idCiudad &&
          filtered.profile_id === values.actor
      );
      setStores(result);
      setHeat(result);
    }
  };

  const positions = heat.map((item, index) => {
    return { lat: parseFloat(item.lat), lng: parseFloat(item.lon) };
  });

  if (loader) {
    return (
      <GridContainer style={{ background: "#fff" }}>
        <GridItem xs={12} md={12}>
          {error ? <Alert severity="error">Error en la consulta.</Alert> : ""}

          <Box sx={{ width: "100%" }}>
            <Skeleton width="100%" height={500} />
          </Box>
        </GridItem>
      </GridContainer>
    );
  } else {
    return (
      <div style={{ background: "#fff", padding: 20 }}>
        <GridContainer>
          <GridItem xs={12} md={3}>
            <LoadFilterActors callback={getResponseActor} />
          </GridItem>
          <GridItem xs={12} md={3}>
            <LoadFilterCitys
              callback={getResponseCity}
              values={values.cityData}
              disabled={disabledCity}
            />
          </GridItem>
          {/*<GridItem xs={12} md={3}>
                <LoadFilterWastes
                  callback={getResponseCity}
                  disabled={disabledWastes}
                />
    </GridItem>*/}
          <GridItem xs={12} md={6}>
            <div style={{ float: "right" }}>
              <FormControl component="fieldset">
                <RadioGroup
                  value={radioValue}
                  onChange={handleChange}
                  row
                  aria-label="position"
                >
                  <FormControlLabel
                    value="b"
                    control={<Radio checked={selectedValue === "b"} />}
                    label="Registros"
                    className={classes.cardTitleGraphs}
                  />
                  <FormControlLabel
                    value="a"
                    control={<Radio checked={selectedValue === "a"} />}
                    label="Mapa de calor"
                    className={classes.cardTitleGraphs}
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </GridItem>
        </GridContainer>
        <br></br>
        <Grid container className={classes.containerMap}>
          <Grid item xs={12} sm={12}>
            <Map
              google={props.google}
              zoom={7}
              style={{ height: 430 }}
              initialCenter={coords}
            >
              {radioValue === "b" ? (
                displayMarkers()
              ) : (
                <HeatMap
                  gradient={gradient}
                  positions={positions}
                  opacity={1}
                  radius={20}
                />
              )}

              {showingInfoWindow ? (
                <InfoWindow marker={activeMarker} visible={showingInfoWindow}>
                  <Fragment>
                    <Typography align="center" variant="subtitle1">
                      <BusinessCenter className={classes.icontext} />
                      {selectedPlace.name}
                    </Typography>
                    <div className={classes.cardTitleGraphs}>
                      <b>Descripción:</b> {selectedPlace.description}
                      <br></br>
                      <b>Perfil:</b> {selectedPlace.profile_name}
                      <br></br>
                      <b>Ciudad:</b> {selectedPlace.city}
                      <br></br>
                      {selectedPlace.sector_name !== null ? (
                        <Fragment>
                          <b>Sector económico:</b> {selectedPlace.sector_name}{" "}
                        </Fragment>
                      ) : (
                        ""
                      )}
                    </div>
                  </Fragment>
                </InfoWindow>
              ) : (
                ""
              )}
            </Map>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyDy8AE5RqF-ozGiI8J7r-U1vnb3AwQCY-o",
  //LoadingContainer: LoadingContainer,
  libraries: ["visualization"],
})(MapRegistrationAll_web);
